import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { RouterLinkProps } from 'vue-router/types/router'

/**
 * Cards are used to group related information and tasks to make things easier
 * to scan, and action upon
 */
type RouterLinkTo = RouterLinkProps['to']

export default /*#__PURE__*/_defineComponent({
  __name: 'VsCard',
  props: {
    title: { default: null },
    noContentPadding: { type: Boolean, default: false },
    raised: { type: Boolean, default: false },
    to: null,
    accent: { default: null }
  },
  setup(__props: any) {

const props = __props as { title: string | null, noContentPadding: boolean, raised: boolean, to?: RouterLinkTo, accent: string | null }


const determineComponent = computed(() => (props.to ? 'router-link' : 'div'))

return { __sfc: true,props, determineComponent, VsHeading, VsWrapper }
}

})